import { useMutation } from '@apollo/client';
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';
// API
import { INVITE_EXT_TALENT_TO_DEAL } from 'api/brandDeals/mutations';
// Types
import { InviteExtTalentToDeal } from 'api/brandDeals/types/InviteExtTalentToDeal';
// Helpers
import {
  clearExtTalentBrandDealAttributionFromStorage,
  getExtTalentBrandDealAttributionFromStorage,
} from 'helpers/extTalentBrandDeal';
import { isStoreRole } from 'helpers/user';
// Constants
import { MANAGE_AMA } from 'constants/routes';
// Hooks
import { useGetCurrUser } from 'hooks';

const BrandDealInviteWatcher = (): null => {
  const router = useRouter();
  const { data } = useGetCurrUser();
  const hasFiredRef = useRef(false);

  const [inviteExtTalentToDeal] = useMutation<InviteExtTalentToDeal>(
    INVITE_EXT_TALENT_TO_DEAL
  );

  useEffect(() => {
    const user = data?.me;
    const isOnboardedStoreUser =
      !!user && isStoreRole(user.role) && user.isOnboarded;

    if (
      hasFiredRef.current ||
      !getExtTalentBrandDealAttributionFromStorage() ||
      !isOnboardedStoreUser
    ) {
      return;
    }

    hasFiredRef.current = true;

    inviteExtTalentToDeal()
      .then(({ data: result }) => {
        if (!result || !('inviteExtTalentToDeal' in result)) {
          clearExtTalentBrandDealAttributionFromStorage();
          router.push(MANAGE_AMA);
          return;
        }

        const invite = result?.inviteExtTalentToDeal;
        clearExtTalentBrandDealAttributionFromStorage();
        if (invite?.campaignId) {
          router.push({
            pathname: `${MANAGE_AMA}/campaigns/${invite.campaignId}`,
            ...(invite.offerId && {
              query: { offerId: invite.offerId, tab: 'details' },
            }),
          });
        } else {
          router.push(MANAGE_AMA);
        }
      })
      .catch((error) => {
        // Transport / server error: keep attribution so a future mount can retry.
        console.error(
          '[ExtTalentBdInvite] inviteExtTalentToDeal failed:',
          error
        );
        router.push(MANAGE_AMA);
      });
  }, [data, inviteExtTalentToDeal, router]);

  return null;
};

export default BrandDealInviteWatcher;
